module.exports = __webpack_public_path__ + "./images/fe.52de48.svg";